import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-protocol-details',
  standalone: true,
  imports: [],
  templateUrl: './modal-protocol-details.component.html',
  styleUrl: './modal-protocol-details.component.scss'
})
export class ModalProtocolDetailsComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef);
  reasons: string[] = [];

  ngOnInit(): void {
    this.reasons = this.data.reasons;
  }
  closeModal(): void {
    this.dialogRef.close();
  }
}
